import { render, staticRenderFns } from "./currencySelectionModal.vue?vue&type=template&id=40e746d6&scoped=true"
import script from "./currencySelectionModal.vue?vue&type=script&lang=js"
export * from "./currencySelectionModal.vue?vue&type=script&lang=js"
import style0 from "./currencySelectionModal.vue?vue&type=style&index=0&id=40e746d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e746d6",
  null
  
)

export default component.exports